<template>
    <div id="app">
        <transition >
            <router-view class="transitionName"></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name:'Finza',
        data(){
            return{
                transitionName:'slide-left',
            }
        },
        methods:{

        },
        watch:{
            '$route'(to,from){
                const toPath=to.path.split('/').length;
                const fromPath=from.path.split('/').length;
                this.transitionName=toPath<fromPath?'slide-right':'slide-left';
            }
        },
    }
</script>
<style rel="stylesheet" lang="scss">
    @import '../public/scss/style';
    @import 'css/common';
</style>



// WEBPACK FOOTER //
// src/finzaapp/App.vue